import ProfessionalProvider from "models/resource-management/professional-provider";
import {
  AllergyResults,
  PatientAllergy,
} from "pages/patient-chart/allergies/patient-allergies";
import { Observable } from "rxjs";
import { of } from "rxjs/observable/of";

export function getAllergies(
  patientChartId: number
): Observable<AllergyResults> {
  return of({
    patientAllergy: [
      {
        allergyType: "Drug",
        allergyName: "Ampicillin",
        allergyId: "2hBmY3hMrcSFsrYp78RmGPd4WPn",
        tenantId: 697190,
        patientChartId: 211033,
        severity: "Severe",
        reaction: "Skin Rash",
        createdBy: 744405,
        createdDatetime: "2024-05-30T13:31:28.710886324Z",
        createdTimezone: "America/New_York",
        isDeleted: false,
        modifiedBy: 744405,
        modifiedDatetime: "2024-05-30T14:22:09.912528347Z",
        modifiedTimezone: "America/New_York",
        historyMetaData: [
          {
            changesMadeTo: "Name/Description",
            previousValue: "Aspirin",
            modifiedBy: 744405,
            modifiedDatetime: "2024-05-30T14:22:09.912528683Z",
            modifiedTimezone: "America/New_York",
            reasonForChange: "change",
          },
        ],
        scriptSureData: {
          allergyType: "2",
          allergyId: "8941,8942,8943,8944",
          routedMedId: 8613,
          reactionId: 1,
          severityId: 2,
        },
      },
      {
        allergyType: "Food",
        allergyName: "milk",
        allergyId: "2hBmZApqnzxlfZiqhC69vZmCj4G",
        tenantId: 697190,
        patientChartId: 211033,
        severity: "Mild",
        reaction: "Other",
        reactionOther: "Patient starts mooing",
        createdBy: 744405,
        createdDatetime: "2024-05-30T13:31:37.472678943Z",
        createdTimezone: "America/New_York",
        isDeleted: false,
        scriptSureData: {
          allergyType: "0",
          allergyId: "8922",
          routedMedId: 0,
          reactionId: 8,
          severityId: 6,
        },
      },
      {
        allergyType: "Food",
        allergyName: "milk",
        allergyId: "2hBmZApqnzxlfZiqhC69vZmCj4G",
        tenantId: 697190,
        patientChartId: 211033,
        severity: "Mild",
        reaction: "m",
        createdBy: 744405,
        modifiedBy: 744405,
        deletedBy: 744405,
        createdDatetime: "2024-05-30T13:31:37.472678943Z",
        createdTimezone: "America/New_York",
        modifiedDatetime: "2024-05-30T14:09:44.566350025Z",
        modifiedTimezone: "America/New_York",
        reasonForDelete: "r",
        isDeleted: true,
        scriptSureData: {
          allergyType: "0",
          allergyId: "8922",
          routedMedId: 0,
          reactionId: 8,
          severityId: 4,
        },
      },
    ] as PatientAllergy[],
    professionalProviders: new Map<number, ProfessionalProvider>(),
  });
}



// WEBPACK FOOTER //
// ./src/providers/patient-charts/patient-allergies-service-mock.ts